"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var lodash_1 = require("lodash");
var colors_1 = require("../../constants/colors");
var utils_1 = require("../../utils");
var setFontWeight = function (element, theme) {
    return lodash_1.get(theme, "theme.axsui.text[" + element + "].fontWeight", 'normal');
};
var defaultStyles = function () {
    return styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n    display: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    margin: ", ";\n    text-align: ", ";\n    text-transform: ", ";\n    -webkit-font-smoothing: antialiased;\n\n    a {\n      color: ", ";\n      text-decoration: none;\n      font-weight: 700;\n    }\n\n    li, ol, p {\n      line-height: 1.5em;\n    }\n  "], ["\n    color: ",
        ";\n    display: ", ";\n    font-size: ", ";\n    font-weight: ", ";\n    margin: ", ";\n    text-align: ", ";\n    text-transform: ", ";\n    -webkit-font-smoothing: antialiased;\n\n    a {\n      color: ", ";\n      text-decoration: none;\n      font-weight: 700;\n    }\n\n    li, ol, p {\n      line-height: 1.5em;\n    }\n  "])), function (_a) {
        var color = _a.color, theme = _a.theme, element = _a.element;
        return element ? utils_1.parseThemePath("axsui.text.elements." + element + ".color", theme, colors_1.colors.GREY_400) :
            utils_1.parseThemePath(color, theme, '#717171');
    }, function (_a) {
        var inline = _a.inline;
        return (inline ? inline : 'block');
    }, function (_a) {
        var element = _a.element, theme = _a.theme;
        return utils_1.parseThemePath(element, theme, '14px');
    }, function (_a) {
        var element = _a.element, theme = _a.theme;
        return setFontWeight(element, theme);
    }, function (_a) {
        var element = _a.element, theme = _a.theme;
        return lodash_1.get(theme, "theme.axsui.text[" + element + "].margin", 0);
    }, function (_a) {
        var align = _a.align;
        return (align ? align : 'left');
    }, function (_a) {
        var textCase = _a.textCase;
        return (textCase ? textCase : 'none');
    }, function (_a) {
        var theme = _a.theme;
        return utils_1.parseThemePath('axsui.brand.primary.default', theme, '#007def');
    });
};
/**
 * The Text component provides styles and semantic meaning for text and headings
 * in a manner consistent with other components.
 */
var Text = /** @class */ (function (_super) {
    __extends(Text, _super);
    function Text() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.rootNode = _this.props.element;
        return _this;
    }
    Text.prototype.render = function () {
        var Root = this.rootNode;
        var restProps = lodash_1.omit(this.props, ['element', 'appearance', 'textCase']);
        return React.createElement(Root, __assign({}, restProps), this.props.children);
    };
    return Text;
}(React.Component));
var StyledText = styled_components_1.default(Text)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), defaultStyles);
var AXSText = function (props) { return React.createElement(StyledText, __assign({}, props), props.children); };
AXSText.defaultProps = {
    align: 'left',
    color: 'text_default',
    element: 'div',
    inline: 'block',
};
exports.default = AXSText;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map